/*
 * Wishlist page renderer — Viridimania
 * Legge gli handle salvati in localStorage (via window.ViridimaniaWishlist)
 * e renderizza la grid di prodotti via fetch /products/[handle].js
 *
 * Le stringhe i18n vengono lette dai data attributes della section.
 */
(function() {
  'use strict';

  function init() {
    const section = document.querySelector('[data-wishlist-section]');
    if (!section) return;

    const loadingEl = section.querySelector('[data-wishlist-loading]');
    const emptyEl = section.querySelector('[data-wishlist-empty]');
    const contentEl = section.querySelector('[data-wishlist-content]');
    const gridEl = section.querySelector('[data-wishlist-grid]');
    const countEl = section.querySelector('[data-wishlist-count]');
    const errorEl = section.querySelector('[data-wishlist-error]');
    const addAllBtn = section.querySelector('[data-wishlist-add-all]');
    const clearBtn = section.querySelector('[data-wishlist-clear]');

    const I18N = {
      countOne: section.dataset.i18nCountOne || '1 item',
      countOtherTpl: section.dataset.i18nCountOtherTpl || '{count} items',
      removeAria: section.dataset.i18nRemoveAria || 'Remove __PRODUCT__',
      addToCart: section.dataset.i18nAddToCart || 'Add to cart',
      soldOut: section.dataset.i18nSoldOut || 'Sold out'
    };

    function show(el) { if (el) el.hidden = false; }
    function hide(el) { if (el) el.hidden = true; }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function(c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function formatMoney(cents) {
      if (cents == null) return '';
      const value = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + value;
    }

    function render(products) {
      if (!products.length) {
        hide(loadingEl); show(emptyEl); hide(contentEl);
        return;
      }

      if (countEl) {
        const text = products.length === 1
          ? I18N.countOne
          : I18N.countOtherTpl.replace('{count}', products.length);
        countEl.textContent = text;
        countEl.hidden = false;
      }

      gridEl.innerHTML = products.map(function(p) {
        const onSale = p.compare_at_price && p.compare_at_price > p.price;
        const discountPct = onSale ? Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100) : 0;
        const image = p.featured_image || (p.images && p.images[0]) || '';
        const imageUrl = typeof image === 'string' ? image : (image && image.src) || '';
        const variantId = p.variants && p.variants[0] ? p.variants[0].id : '';

        let html = '<li class="wishlist-card" data-handle="' + p.handle + '">';
        html +=   '<a href="' + p.url + '" class="wishlist-card__media">';
        if (imageUrl) {
          html += '<img src="' + imageUrl + '&width=600" alt="' + escapeHtml(p.title) + '" loading="lazy" class="wishlist-card__image">';
        }
        if (onSale) html += '<span class="wishlist-card__badge">-' + discountPct + '%</span>';
        if (!p.available) html += '<span class="wishlist-card__badge" style="background:#1a1a1a;top:auto;bottom:10px">' + I18N.soldOut + '</span>';
        html +=   '</a>';
        html +=   '<div>';
        html +=     '<a href="' + p.url + '" class="wishlist-card__title">' + escapeHtml(p.title) + '</a>';
        html +=     '<p class="wishlist-card__price">' + formatMoney(p.price);
        if (onSale) html += '<span class="wishlist-card__price-compare">' + formatMoney(p.compare_at_price) + '</span>';
        html +=     '</p>';
        html +=     '<div class="wishlist-card__actions">';
        html +=       '<button type="button" class="btn btn--primary wishlist-card__add" data-add-to-cart data-variant-id="' + variantId + '"' + (p.available ? '' : ' disabled') + '>' + (p.available ? I18N.addToCart : I18N.soldOut) + '</button>';
        html +=       '<button type="button" class="wishlist-card__remove" data-wishlist-toggle data-wishlist-handle="' + p.handle + '" aria-label="' + I18N.removeAria.replace('__PRODUCT__', escapeHtml(p.title)) + '">';
        html +=         '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" aria-hidden="true">';
        html +=           '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>';
        html +=         '</svg>';
        html +=       '</button>';
        html +=     '</div>';
        html +=   '</div>';
        html += '</li>';
        return html;
      }).join('');

      hide(loadingEl); hide(emptyEl); show(contentEl);
    }

    async function loadProducts(handles) {
      if (!handles.length) { render([]); return; }
      try {
        const requests = handles.map(function(h) {
          return fetch('/products/' + encodeURIComponent(h) + '.js')
            .then(function(r) { return r.ok ? r.json() : null; })
            .catch(function() { return null; });
        });
        const results = await Promise.all(requests);
        const products = results.filter(Boolean);

        // Rimuovi handle non più validi
        const validHandles = products.map(function(p) { return p.handle; });
        handles.forEach(function(h) {
          if (validHandles.indexOf(h) === -1 && window.ViridimaniaWishlist) {
            window.ViridimaniaWishlist.remove(h);
          }
        });

        if (products.length < handles.length && errorEl) errorEl.hidden = false;
        render(products);
      } catch (e) {
        console.error('[wishlist] errore caricamento', e);
        if (errorEl) errorEl.hidden = false;
        hide(loadingEl);
      }
    }

    function start() {
      if (!window.ViridimaniaWishlist) {
        hide(loadingEl); show(emptyEl);
        return;
      }
      loadProducts(window.ViridimaniaWishlist.list());
      window.ViridimaniaWishlist.on('change', function() {
        const newHandles = window.ViridimaniaWishlist.list();
        if (!newHandles.length) render([]);
        else loadProducts(newHandles);
      });
    }

    // Toolbar: add all
    if (addAllBtn) {
      addAllBtn.addEventListener('click', async function() {
        const cards = gridEl.querySelectorAll('[data-handle]');
        const items = [];
        cards.forEach(function(card) {
          const btn = card.querySelector('[data-variant-id]');
          if (btn && !btn.disabled) {
            const vid = btn.getAttribute('data-variant-id');
            if (vid) items.push({ id: parseInt(vid, 10), quantity: 1 });
          }
        });
        if (!items.length) return;
        addAllBtn.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          window.location.href = '/cart';
        } catch (e) {
          addAllBtn.disabled = false;
        }
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (window.ViridimaniaWishlist) window.ViridimaniaWishlist.clear();
      });
    }

    gridEl.addEventListener('click', async function(e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        });
        window.location.href = '/cart';
      } catch (e) {
        btn.disabled = false;
      }
    });

    // wishlist.js è caricato con defer. Aspetta che ViridimaniaWishlist sia disponibile.
    if (window.ViridimaniaWishlist) {
      start();
    } else {
      // Polling breve come fallback (max 1 secondo)
      let tries = 0;
      const interval = setInterval(function() {
        tries++;
        if (window.ViridimaniaWishlist || tries > 20) {
          clearInterval(interval);
          start();
        }
      }, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
